export const LOG_IN = '/login';
export const MAP_VIEW = '/';

